import {
  TDevice,
  TDeviceObstructionStatus,
} from "src/data/devices/types/deviceTypes"

export function isDeviceObstructed(device: TDevice): boolean {
  return getObstructionStatus(device.obstruction) === "obstructed"
}

export function getObstructionStatus(
  obstruction: TDevice["obstruction"]
): TDeviceObstructionStatus | undefined {
  if (!obstruction) {
    return undefined
  }

  return obstruction.status
}
